var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box page-pre-invoice-generation-form" }, [
    _c("div", { staticClass: "columns is-multiline" }, [
      _c(
        "div",
        { staticClass: "column" },
        [
          _c(
            "sc-field",
            { attrs: { label: "Centros de Distribuição", prop: "warehouses" } },
            [
              _c("sc-warehouse-dropdown", {
                attrs: {
                  id: "pre-invoice-form-warehouses",
                  "list-user": "",
                  dropdown: ""
                },
                on: {
                  selectAll: function(values) {
                    return (_vm.fields.warehouses = values)
                  },
                  clearFilter: function() {
                    return (_vm.fields.warehouses = [])
                  }
                },
                model: {
                  value: _vm.fields.warehouses,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "warehouses", $$v)
                  },
                  expression: "fields.warehouses"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "column" },
        [
          _c(
            "sc-field",
            { attrs: { label: "Transportadora", prop: "logistic_providers" } },
            [
              _c("sc-logistic-provider-dropdown", {
                attrs: {
                  id: "pre-invoice-form-logisticProviders",
                  options: _vm.enumStatus,
                  active: false,
                  dropdown: ""
                },
                on: {
                  selectAll: function(values) {
                    return (_vm.fields.logistic_providers = values)
                  },
                  clearFilter: function() {
                    return (_vm.fields.logistic_providers = [])
                  }
                },
                model: {
                  value: _vm.fields.logistic_providers,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "logistic_providers", $$v)
                  },
                  expression: "fields.logistic_providers"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "column" },
        [
          _c(
            "sc-field",
            { attrs: { label: "Método de entrega", prop: "delivery_methods" } },
            [
              _c("sc-delivery-method-dropdown", {
                attrs: {
                  id: "pre-invoice-form-deliveryMethods",
                  "logistic-provider-id": _vm.fields.logistic_providers,
                  dropdown: ""
                },
                on: {
                  selectAll: function(values) {
                    return (_vm.fields.delivery_methods = values)
                  },
                  clearFilter: function() {
                    return (_vm.fields.delivery_methods = [])
                  }
                },
                model: {
                  value: _vm.fields.delivery_methods,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "delivery_methods", $$v)
                  },
                  expression: "fields.delivery_methods"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "column" },
        [
          _c(
            "sc-field",
            { attrs: { label: "Data de despacho", prop: "date_range" } },
            [
              _c("sc-range-date-picker", {
                attrs: {
                  id: "pre-invoice-form-datePicker",
                  format: _vm.formatDate,
                  "min-date": _vm.minDate,
                  "max-date": _vm.maxDate
                },
                model: {
                  value: _vm.fields.date_range,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "date_range", $$v)
                  },
                  expression: "fields.date_range"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "columns is-multiline" }, [
      _c(
        "div",
        { staticClass: "column" },
        [
          _c(
            "sc-field",
            { attrs: { label: "Status", prop: "status" } },
            [
              _c("sc-multiple-selection", {
                attrs: {
                  id: "pre-invoice-form-status",
                  options: _vm.enumStatus
                },
                on: {
                  clearFilter: function() {
                    return (_vm.fields.status = [])
                  },
                  selectAll: function(values) {
                    return (_vm.fields.status = values)
                  }
                },
                model: {
                  value: _vm.fields.status,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "status", $$v)
                  },
                  expression: "fields.status"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "column" },
        [
          _c(
            "sc-field",
            { attrs: { prop: "margin_status" } },
            [
              _c(
                "template",
                { attrs: { slot: "label" }, slot: "label" },
                [
                  _vm._v("\n          Conferência\n          "),
                  _c(
                    "sc-tooltip",
                    {
                      attrs: {
                        type: "is-light",
                        position: "is-right",
                        label:
                          "Permite selecionar as notas cuja divergência de valor do frete para o do CTe está dentro da tolerância parametrizada"
                      }
                    },
                    [
                      _c("sc-icon", {
                        attrs: { size: "is-small", icon: "info-circle" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "sc-select",
                {
                  attrs: { id: "pre-invoice-form-marginStatus", expanded: "" },
                  model: {
                    value: _vm.fields.margin_status,
                    callback: function($$v) {
                      _vm.$set(_vm.fields, "margin_status", $$v)
                    },
                    expression: "fields.margin_status"
                  }
                },
                [
                  _c("option", { attrs: { selected: "", value: "" } }, [
                    _vm._v("Todos")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.enumMarginStatus, function(option) {
                    return _c(
                      "option",
                      { key: option.value, domProps: { value: option.value } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(option.label) +
                            "\n          "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "column" },
        [
          _c(
            "sc-field",
            { attrs: { prop: "difference" } },
            [
              _c(
                "template",
                { attrs: { slot: "label" }, slot: "label" },
                [
                  _vm._v("\n          Diferença\n          "),
                  _c(
                    "sc-tooltip",
                    {
                      attrs: {
                        type: "is-light",
                        position: "is-left",
                        label:
                          "Permite selecionar faturas comparando os Valores do TMS e do CTe"
                      }
                    },
                    [
                      _c("sc-icon", {
                        attrs: { size: "is-small", icon: "info-circle" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "sc-select",
                {
                  attrs: { id: "pre-invoice-form-marginDiff", expanded: "" },
                  model: {
                    value: _vm.fields.difference,
                    callback: function($$v) {
                      _vm.$set(_vm.fields, "difference", $$v)
                    },
                    expression: "fields.difference"
                  }
                },
                [
                  _c("option", { attrs: { selected: "", value: "" } }, [
                    _vm._v("Todos")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.enumDifferenceValues, function(option) {
                    return _c(
                      "option",
                      { key: option.value, domProps: { value: option.value } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(option.label) +
                            "\n          "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ],
            2
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "columns is-multiline" }, [
      _c(
        "div",
        { staticClass: "column is-4" },
        [
          _c(
            "sc-field",
            { attrs: { label: "Buscar por", prop: "search_by" } },
            [
              _c(
                "sc-select",
                {
                  attrs: { id: "pre-invoice-form-searchBy", expanded: "" },
                  model: {
                    value: _vm.fields.search_by,
                    callback: function($$v) {
                      _vm.$set(_vm.fields, "search_by", $$v)
                    },
                    expression: "fields.search_by"
                  }
                },
                [
                  _c(
                    "option",
                    { attrs: { selected: "", value: "order_number" } },
                    [_vm._v("Pedido")]
                  ),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "invoice_number" } }, [
                    _vm._v("Nota Fiscal")
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.fields.search_by === "order_number"
        ? _c(
            "div",
            { staticClass: "column" },
            [
              _c(
                "sc-field",
                { attrs: { label: "Pedido", prop: "search_values" } },
                [
                  _c("sc-taginput", {
                    attrs: {
                      id: "pre-invoice-form-orderNumberInput",
                      placeholder: "Informe um ou mais pedidos",
                      "on-paste-separators": [",", " "],
                      maxtags: 500
                    },
                    model: {
                      value: _vm.fields.search_values,
                      callback: function($$v) {
                        _vm.$set(_vm.fields, "search_values", $$v)
                      },
                      expression: "fields.search_values"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.fields.search_by === "invoice_number"
        ? _c(
            "div",
            { staticClass: "column" },
            [
              _c(
                "sc-field",
                { attrs: { label: "Nota Fiscal", prop: "search_values" } },
                [
                  _c("sc-taginput", {
                    attrs: {
                      id: "pre-invoice-form-invoiceNumberInput",
                      placeholder: "Informe um ou mais NFs",
                      "on-paste-separators": [",", " "],
                      maxtags: 500
                    },
                    model: {
                      value: _vm.fields.search_values,
                      callback: function($$v) {
                        _vm.$set(_vm.fields, "search_values", $$v)
                      },
                      expression: "fields.search_values"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "sc-form__footer columns page-pre-invoice-generation-form__footer"
      },
      [
        _c("div", { staticClass: "column" }, [
          _c(
            "div",
            { staticClass: "buttons is-right" },
            [
              _c("sc-button", {
                attrs: {
                  id: "pre-invoice-export-button",
                  text: "Exportar para o Excel",
                  loading: _vm.loadingExports,
                  disabled: !_vm.isValid
                },
                on: {
                  click: function($event) {
                    _vm.$emit("exportToExcel", _vm.fields)
                  }
                }
              }),
              _vm._v(" "),
              _c("sc-button", {
                attrs: {
                  id: "pre-invoice-clear-button",
                  type: "button",
                  text: "Limpar filtros"
                },
                on: {
                  click: function($event) {
                    _vm.$emit("clearFilters")
                  }
                }
              }),
              _vm._v(" "),
              _c("sc-button", {
                attrs: {
                  id: "pre-invoice-search-button",
                  type: "submit",
                  theme: "primary",
                  text: "Buscar"
                }
              })
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61c01b40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61c01b40","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-generation/components/sc-pre-invoice-generation-form/ScPreInvoiceGenerationForm.vue
// module id = null
// module chunks = 